// extracted by mini-css-extract-plugin
export default {"category":"Category_category__ZnBB8","image":"Category_image__MjQAU","skeleton":"Category_skeleton__YrxAI"};